import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { RiHome6Line } from "react-icons/ri";
import Logo from '../Components/Images/Logo base.svg';
import Avatar from '../Components/Images/Avatar.png';
import close from '../Components/Images/close.png';
import Beneficiary from '../Components/Images/beneficiary.svg';
import Transaction from '../Components/Images/transaction.svg';
import Invoice from '../Components/Images/Invoice.svg';
import Settings from '../Components/Images/Settings.svg';
import { Context } from '../Context/Context';
import ConfirmLogOut from './ConfirmLogOut';
import smiley from '../Components/Images/smileyFace.png'
import logoutIcon from '../Components/Images/logoutIcon.png'


const SMSideBar = ({ verified, UserProfile }) => {
    const location = useLocation();
    // const navigate = useNavigate();

    const [onLogOut, setOnLogOut] = useState(false)
    const [onClick, setOnclick] = useState(false)


    // const getRandomColor = () => {
    //     const colors = [
    //         "#F87171", // red-400
    //         "#60A5FA", // blue-400
    //         "#34D399", // green-400
    //         "#FBBF24", // yellow-400
    //         "#A78BFA", // purple-400
    //         "#FB7185", // pink-400
    //         "#F97316", // orange-400
    //         "#38BDF8", // sky-400
    //     ];
    //     return colors[Math.floor(Math.random() * colors.length)];
    // };

    // const bgColor = useMemo(() => getRandomColor(), []);



    const { handleSideBar, sideBar, setSideBar, setTransactionType } = useContext(Context)

    const [isLgScreen, setIsLgScreen] = useState(window.innerWidth > 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsLgScreen(window.innerWidth > 1024);
        };

        if (isLgScreen) {
            setSideBar(false)
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [setSideBar, isLgScreen]);

    // const handleRedirectIfUnverified = (e, targetPath) => {
    //     e.preventDefault();
    //     handleSideBar();
    //     if (verified) {
    //         navigate(targetPath);
    //     } else {
    //         navigate('/dashboard', {
    //             state: { error: 'You need to fill in your KYC data to continue' }
    //         });
    //     }
    // };

    const menuItems = [
        { path: '/home', label: 'Home', icon: <RiHome6Line className="text-[21px]" /> },
        { path: '/beneficiaries', label: 'Accounts', icon: <img src={Beneficiary} className='size-5' alt="" /> },
        { path: '/invoices', label: 'Invoices', icon: <img src={Invoice} className='size-5' alt="" /> },
        { path: '/transactions', label: 'Transactions', icon: <img src={Transaction} className='size-5' alt="" /> },
        { path: '/settings', label: 'Settings', icon: <img src={Settings} className='size-5' alt="" /> },
    ];

    return (
        <div className={`bg-[#431594] hide-scrollbar overflow-y-scroll py-10 text-white sp:w-[300px] w-full h-screen top-0 left-0 px-5 fixed flex lg:hidden justify-between flex-col z-50 gap-5 ${sideBar ? 'fixed' : 'hidden'}`}>
            <div className=''>
                <div className="flex items-center justify-between">
                    <Link
                        to={verified ? '/home' : '/dashboard'}
                        onClick={(e) => {
                            handleSideBar()
                            // handleRedirectIfUnverified(e, verified ? '/home' : '/dashboard')
                            setOnclick(false);
                        }}
                    >
                        <h1 className="flex gap-2 items-center font-semibold ml-2 text-[20px]">
                            <img src={Logo} alt="" className="mt-1" />
                            <p className='text-xl font-medium'>reccur</p>
                        </h1>
                    </Link>
                    <img
                        onClick={handleSideBar}
                        src={close}
                        alt=""
                        className="cursor-pointer"
                    />
                </div>

                {/* Sidebar Menu */}
                <div className="flex flex-col gap-2 mt-5">
                    {menuItems.map(({ path, label, icon }) => (
                        <Link
                            to={path}
                            key={label}
                            onClick={(e) => {
                                handleSideBar()
                                // handleRedirectIfUnverified(e, path)
                                setOnclick(false);
                            }}
                        >
                            <div
                                className={`${location.pathname === path
                                    ? 'bg-[#4e22a0]'
                                    : 'hover:bg-[#4e22a0]'
                                    } flex items-center gap-2 cursor-pointer rounded-md p-2`}
                            >
                                {icon}
                                <p>{label}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            {/* Profile Section */}
            <div className='relative'>
                <div className={`w-full text-white rounded-lg py-2 px-4 bg-[#5a20bf] text-[18px] text-center z-0 absolute transition-all duration-500 left-0 ${!onClick ? 'hidden' : 'bottom-[90px]'}`}>
                    <Link
                        to="/settings"
                        aria-label="Edit Profile"
                        onClick={() => {
                            setTransactionType('account');
                            handleSideBar();
                            setOnclick(false);
                        }}
                    >
                        <span className='py-2 flex gap-3 items-center'>
                            <img src={smiley} alt="" />
                            Edit profile
                        </span>
                    </Link>
                    <p
                        onClick={() => setOnLogOut(!onLogOut)}
                        className='py-2 cursor-pointer flex gap-3 items-center'
                    >
                        <img src={logoutIcon} alt="" />
                        Logout
                    </p>
                </div>

                <div onClick={() => setOnclick(!onClick)} className="flex items-center bg-[#431594] sk:mb-0 mb-6 z-50 justify-between">
                    <div className="flex w-full items-center cursor-pointer z-50 gap-2">
                        <label htmlFor="ProfilePics">
                            <div className="flex gap-6">
                                {/* {UserProfile?.image ? (
                                    <img
                                        src={UserProfile.image}
                                        alt=""
                                        className="rounded-[48px] size-9 cursor-pointer"
                                    />
                                ) : (
                                    <div
                                        className="flex items-center justify-center cursor-pointer rounded-full text-[24px] size-11 text-white font-semibold uppercase"
                                        style={{ backgroundColor: bgColor }}
                                    >
                                        {UserProfile?.last_name?.charAt(0) || "?"}
                                    </div>
                                )} */}
                                <img
                                    src={Avatar}
                                    alt=""
                                    className="rounded-[48px] size-9 cursor-pointer"
                                />
                            </div>
                        </label>
                        <p className='z-50'>{UserProfile?.fullname}</p>
                    </div>
                    <p>
                        <BsThreeDots
                            className="text-[20px] z-50 cursor-pointer"
                        />
                    </p>
                </div>
            </div>

            <ConfirmLogOut onLogOut={onLogOut} setOnLogOut={setOnLogOut} />
        </div>
    )
}

export default SMSideBar